import {businessEn} from "./business/en";

export const departmentEn = {
    department: {
        pageHeader: {
            add: "Create new department",
            update: "update department",
            information: "Department information"
        },
        breadCrumb: {
            title: "List Department"
        },
        header: {
            create: "Create new department",
            update: "update department"
        },
        row: {
            department: "Department",
            company: "Company",
            branch: "Branch",
            unit: "Unit",
            trashed: "Trashed",
            pending: "Pending",
            approved: "Approved"
        },
        sider: {
            Label: "Manager Department",
            list: "List Department",
            "import": "Import list department",
            "export": "Export list department",
            "create": "Create department",
            "update": "update department"
        },
        "label": {
            "type":"Type",
            "tax": "Tax",
            "name": "Name",
            "business": "Business Name",
            "code": "Code",
            "address": "Address",
            "parentId": "Department Parent",
            "headOffice": "Head Office",
            "alias": "Alias",
            "description": "Description",
            "order": "Order"
        },
        "message": {
            "tax": "Please enter tax number",
            "name": "Please enter name",
            "business": "Please enter business name",
            "code": "Please enter code",
            "address": "Please enter address",
            "headOffice": "Please enter department head office",
            "parentId": "Please enter department parent",
            "alias": "Please enter alias",
            "add": "Create a new department completely",
            "update": "update department completely",
            "error": "Something went wrong, please try again",
            "delete": "Delete department completely"
        },
        "placeholder": {
            "tax": "Enter tax number",
            "name": "Enter name",
            "business": "Enter business name",
            "code": "Enter code",
            "address": "Enter address",
            "headOffice": "Enter department head office",
            "parentId": "Enter department parent",
            "alias": "Enter alias"
        },
        "table": {
            "name": "Name",
            "typeName": "Type",
            "business": "Business Name"
        },
        "option": {
            "company": "Company",
            "branch": "Branch",
            "unit": "Unit",
            "department": "Department"
        },
        "plusOutlined": {
            "business": "Create"
        }
    },
    ...businessEn
}
